export default __webpack_public_path__ + "static/media/api.bbb01360.svg";